module.exports = __webpack_public_path__ + "media/src/fonts/LineIcons-fb16b8b0de9e73ca9b2d7bb18c4e7108.ttf";